module.exports = __webpack_public_path__ + "static/v_1-e65b588009b095f7c259f49fba61260c.mp4";